<!-- Show loading status when logging in or loading user info -->
<app-loading-status *ngIf="isLoggingIn || shouldShowLoading()"></app-loading-status>

<!-- Login form: same auth layout as Access Denied page -->
<div class="auth-page" *ngIf="!isLoggingIn && shouldShowLoginForm()">
  <div class="auth-bg-pattern"></div>
  <div class="auth-card">
    <div class="auth-brand">
      <div class="auth-brand-logo">
        <i class="pi pi-chart-bar"></i>
      </div>
      <div class="auth-brand-text">
        <span class="auth-brand-name">APEX</span>
        <span class="auth-brand-sub">BISTEC Global</span>
      </div>
    </div>

    <div class="auth-divider"></div>

    <h1 class="auth-title">Welcome back</h1>
    <p class="auth-subtitle">Sign in to access the Resource Allocation & Planning System</p>

    <button type="button" class="auth-btn auth-btn-primary" (click)="login()" [disabled]="isLoggingIn">
      <svg class="auth-ms-icon" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="11" height="11" fill="#f25022"/>
        <rect x="12" width="11" height="11" fill="#7fba00"/>
        <rect y="12" width="11" height="11" fill="#00a4ef"/>
        <rect x="12" y="12" width="11" height="11" fill="#ffb900"/>
      </svg>
      <span class="auth-btn-text">{{ isLoggingIn ? 'Signing in...' : 'Continue with Microsoft' }}</span>
    </button>

    <p class="auth-footer">
      <i class="pi pi-lock auth-icon-sm"></i>
      Secured by Microsoft Entra ID
    </p>
  </div>
</div>
